import Vue from 'vue'
import Vuex from 'vuex'
import $cookies from 'vue-cookies'
Vue.use(Vuex)
const store = new Vuex.Store({
	state: sessionStorage.getItem('state') ? JSON.parse(sessionStorage.getItem('state')) : {
		screenSize: ''
	},
	mutations: {
		setScreenSize(state, size) {
			state.screenSize = size;
		},
	},
	actions: {
		setScreenSize(state, data) {
			state.commit('setScreenSize', data)
		},
	}
})
export default store


// WEBPACK FOOTER //
// ./src/store/index.js